import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the window scroll to the top on route change so a visitor starts every
 * marketing/content page from the beginning, instead of landing mid-page where
 * the previous page happened to be scrolled. React Router (non-data mode) does
 * not restore scroll on its own.
 *
 * Two deliberate exceptions:
 *  - Hash links (e.g. /#features, /#pricing) are left alone so in-page anchor
 *    navigation keeps working.
 *  - The authenticated app/admin (/app, /admin) is skipped — those layouts
 *    manage their own scroll, and this is only meant for the public pages.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    if (pathname.startsWith("/app") || pathname.startsWith("/admin")) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;